import Vue from 'vue'
import VueRouter from 'vue-router'
import { doc, getDoc } from 'firebase/firestore'
import { auth, db } from '@/firebase'
import HomeView from '../views/HomeView.vue'
import AdminHomeView from "@/views/AdminHomeView.vue";
import AdminSearchView from "@/views/AdminSearchView.vue";
import Profile from '../views/Profile.vue'
import CreatePostView from '@/views/CreatePostView.vue'
import SignInView from '@/views/SignInView.vue';
import SearchView from '@/views/SearchView.vue';
import UserDetailsView from '@/views/UserDetailsView.vue';
import ConversationView from '@/views/ConversationView.vue';
import ChatView from '@/views/ChatView.vue';
import GroupView from '@/views/GroupView.vue';
import GroupListView from '@/views/GroupView.vue';
import GroupDetailView from '@/views/GroupDetailView.vue';
import MemberDetailView from '@/views/MemberDetailView.vue';
import MemberFriendsView from '@/views/MemberFriendsView.vue';
import MemberSettingsView from "@/views/MemberSettingsView.vue";
import AddMemberView from '@/views/AddMemberView.vue';
import PostsView from '@/views/PostsView.vue';
import AdminSettingsView from "@/views/AdminSettingsView.vue";
import ExploreView from '@/views/ExploreView.vue';
import AdminWaitlist from "@/views/AdminWaitlist.vue";
import NdaConductView from '@/views/NdaConductView.vue'
import PrivacyView from "@/views/PrivacyView.vue";
import TermsView from "@/views/TermsView.vue";

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'SignIn', component: SignInView },
  { path: '/home', name: 'HomeView', component: HomeView },
  { path: "/admin-home", name: "AdminHomeView", component: AdminHomeView, meta: { requiresAdmin: true } },
  { path: "/admin-search", name: "AdminSearch", component: AdminSearchView },
  { path: "/admin-settings", name: "AdminSettings", component: AdminSettingsView },
  {
  path: '/admin/analytics',
  name: 'AdminAnalytics',
  component: () => import('@/views/AdminAnalyticsView.vue'),
  meta: { requiresAdmin: true }, // however you gate other admin routes
},
  { path: '/profile', name: 'Profile', component: Profile },
  { path: '/search', name: 'Search', component: SearchView },
  { path: '/messages', name: 'Messages', component: ConversationView },
  { path: '/member-details', name: 'MemberDetails', component: UserDetailsView },
  { path: "/admin/waitlist", name: "AdminWaitlist", component: AdminWaitlist, meta: { requiresAdmin: true } },
  {
    path: "/admin/flags",
    name: "AdminFlags",
    component: () => import("@/views/AdminFlaggedPostsView.vue"),
    meta: { requiresAdmin: true },
  },
  {
    path: '/member',
    name: 'MemberFriendsView',
    component: MemberFriendsView,
    props: true
  },
  { path: "/member-settings", name: "MemberSettings", component: MemberSettingsView },
  {
    path: '/post/:postId',
    name: 'PostDetail',
    component: () => import('@/views/PostDetail.vue'),
    props: route => ({
      post: route.params.post,
      postId: route.params.postId,
      replyId: route.params.replyId || null,
    }),
  },
  {
    path: '/groups/create',
    name: 'CreateGroup',
    component: () => import('@/views/CreateGroupView.vue'),
  },  
  {
    path: "/member-profile/:id",
    name: "MemberProfile",
    component: () => import("@/views/MemberProfileView.vue"),
    props: true,
  },
  {
    path: '/personal-information',
    name: 'PersonalInformationView',
    component: () => import('@/views/PersonalInformationView.vue'),
  },  
  {
    path: '/explore',
    name: 'ExploreView',
    component: ExploreView // ✅ New Explore route
  },
  {
    path: '/explore-post/:postId',
    name: 'ExplorePostDetail',
    component: () => import('@/views/ExplorePostDetail.vue'),
    props: route => ({
      postId: route.params.postId,
      replyId: route.params.replyId || null,
    }),
  },  
  {
    path: '/notifications',
    name: 'Notifications',
    component: () => import('@/views/NotificationView.vue') // adjust path if needed
  }, 
  { path: '/chat/:friendId', name: 'ChatView', component: ChatView, props: true },
  { path: '/groups', name: 'GroupView', component: GroupView },
  { path: '/group-list', name: 'GroupListView', component: GroupListView },
  { path: '/group/:id/create-post', name: 'CreatePostView', component: CreatePostView, props: true },
  { path: '/add-member', name: 'AddMemberView', component: AddMemberView },
  { path: '/posts', name: 'PostsView', component: PostsView }, 
  {
    path: '/member-applications',
    name: 'MemberApplications',
    component: () => import('@/views/MemberApplicationsView.vue')
  },
  {
    path: "/member-bio/:id",
    name: "MemberBio",
    component: () => import("@/views/MemberBioView.vue"),
    props: true,
  },     
  {
    path: '/post/:postID/comments',
    name: 'CommentsView',
    component: () => import('@/views/CommentsView.vue'),
    props: true,
  },
  {
    path: "/waitlist-register",
    name: "WaitlistRegister",
    component: () => import("@/views/WaitlistRegister.vue"),
    meta: { public: true },
  },
  {
    path: "/waitlist/complete",
    name: "WaitlistComplete",
    component: () => import("@/views/WaitlistComplete.vue"),
    meta: { public: true },
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: PrivacyView,
    meta: { public: true, title: 'Privacy · The Boardnet' }
  },
  {
    path: '/terms',
    name: 'terms',
    component: TermsView,
    meta: { public: true, title: 'Terms · The Boardnet' }
  },
  {
  path: '/nda',
  name: 'nda',
  component: NdaConductView,
  meta: { public: true, title: 'NDA & Code of Conduct · The Inner Network' }
},
  {
    path: '/help',
    name: 'HelpView',
    component: () => import('@/views/HelpView.vue'),
    meta: { title: 'Help & FAQ · The Inner Network' },
  },
  {
    path: '/about',
    name: 'AboutView',
    component: () => import('@/views/AboutView.vue'),
    meta: { title: 'About · The Inner Network' },
  },
  {
    path: "/groups/:id",
    name: "GroupDetail",
    component: GroupDetailView,
    props: true,
  },
  {
    path: "/member-detail/:id",
    name: "MemberDetail",
    component: MemberDetailView,
    props: true,
  },
  {
    path: '/admin-messages',
    name: 'AdminMessages',
    component: () => import('@/views/AdminConversationList.vue')
  },
  // Catch-all: any unmatched URL falls back to Sign In instead of a blank page
  {
    path: '*',
    redirect: '/',
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Firebase's auth state loads asynchronously, so wait for the first
// resolution before letting any navigation through — otherwise a real,
// logged-in user can get bounced to Sign In on a hard refresh just
// because auth.currentUser hasn't populated yet.
let authReady
const authReadyPromise = new Promise((resolve) => {
  authReady = resolve
})
let currentUser = null
auth.onAuthStateChanged((user) => {
  currentUser = user
  authReady()
})

router.beforeEach(async (to, from, next) => {
  await authReadyPromise

  const isPublic =
    to.matched.some((record) => record.meta && record.meta.public) ||
    to.name === 'SignIn'

  if (!isPublic && !currentUser) {
    next('/')
    return
  }

  const requiresAdmin = to.matched.some((record) => record.meta && record.meta.requiresAdmin)
  if (requiresAdmin) {
    try {
      const userSnap = await getDoc(doc(db, 'user', currentUser.uid))
      const userType = userSnap.exists() ? (userSnap.data().type || userSnap.data().role) : null
      if (userType !== 'Admin') {
        next('/home')
        return
      }
    } catch (e) {
      next('/home')
      return
    }
  }

  next()
})

export default router